import { CampaignModal } from "../components/Modals";
import { CampaignTable } from "../components/Tables";
import { useCampaignStore } from "../store/campaignStore";

export const Pledge = () => {
  const campaignModalOpen = useCampaignStore(state => state.campaignModalOpen);
  const selectedCampaign = useCampaignStore(state => state.selectedCampaign);
  const openCampaignModal = useCampaignStore(state => state.openCampaignModal);
  const closeCampaignModal = useCampaignStore(
    state => state.closeCampaignModal
  );

  return (
    <>
      <CampaignModal
        isOpen={campaignModalOpen}
        onClose={closeCampaignModal}
        data={selectedCampaign}
      />
      <CampaignTable
        onEdit={openCampaignModal}
        onOpenModal={() => openCampaignModal()}
      />
    </>
  );
};
